import { TextStyle as p } from "../../node_modules/@tiptap/extension-text-style/dist/index.mjs";
import { Plugin as g, PluginKey as k } from "../../node_modules/prosemirror-state/dist/index.mjs";
const u = new k("restoreMarks"), v = p.extend({
  addProseMirrorPlugins() {
    return [P()];
  }
}), P = () => new g({
  key: u,
  appendTransaction: (a, l, o) => {
    const i = a.some((t) => t.docChanged), c = !l.selection.eq(o.selection);
    if (!i && !c)
      return null;
    const { selection: d } = o, { $head: e } = d;
    if (e.parent.type.name === "paragraph" && (e.parent.content.size === 0 || e.parent.content.size === 1 && e.parent.textContent === "")) {
      let t = o.storedMarks || e.marks();
      if ((!t || t.length === 0) && e.depth > 0) {
        const r = e.before(e.depth) - 1;
        if (r > 0) {
          const s = o.doc.nodeAt(r);
          if (s && s.content.size > 0) {
            const n = r + s.content.size;
            t = o.doc.resolve(n).marks();
          }
        }
      }
      if (t && t.length > 0) {
        const r = [
          "bold",
          "italic",
          "strike",
          "underline",
          "textStyle",
          "textColor",
          "textBackgroundColor",
          "fontSize",
          "fontFamily"
        ], s = t.filter((n) => r.includes(n.type.name));
        if (s.length > 0) {
          const n = o.tr;
          return n.setStoredMarks(s), n;
        }
      } else {
        const r = o.tr;
        return r.setStoredMarks([]), r;
      }
    }
    return null;
  }
});
export {
  v as TextStyle
};
